/**
 *
 * @param {{}} currentPatient
 * @param {Array} existingPatients
 * @param {Array} keys
 * @param looseComparison
 * @return {{}[]}
 */
export default function filterExistingPatients(currentPatient, existingPatients, keys, looseComparison = false) {
  return existingPatients.filter((existingPatient) => {
    for (const key of keys) {
      if (Object.hasOwn(currentPatient, key) && Object.hasOwn(existingPatient, key)) {
        let currentValue = (currentPatient[key] ?? "").toString().toLowerCase();
        let existingValue = (existingPatient[key] ?? "").toString().toLowerCase();

        if (looseComparison === false && currentValue !== existingValue) {
          return false;
        }
        if (looseComparison === true && !existingValue.startsWith(currentValue)) {
          return false;
        }
      }
    }

    // always check on the id (we do not want to notify
    // an existing patient for himself)
    if (
      Object.hasOwn(currentPatient, "id") &&
      Object.hasOwn(existingPatient, "id") &&
      currentPatient["id"] !== null &&
      currentPatient["id"] !== undefined &&
      currentPatient["id"] === existingPatient["id"]
    ) {
      return false;
    }

    return true;
  });
}
